import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './navbar8.css'

const Navbar8 = (props) => {
  const [link5DropdownVisible, setLink5DropdownVisible] = useState(false)
  const [link5AccordionOpen, setLink5AccordionOpen] = useState(false)
  return (
    <header className={`navbar8-container ${props.rootClassName} `}></header>
  )
}

Navbar8.defaultProps = {
  page1: undefined,
  linkUrlPage3: 'https://www.teleporthq.io',
  page4ImageSrc:
    'https://images.unsplash.com/photo-1664277497087-51787d2b9d15?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NHw&ixlib=rb-4.1.0&q=80&w=1080',
  page4ImageAlt: 'Image for Contact',
  page2Description: undefined,
  page3Description: undefined,
  logoSrc:
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/84ec08e8-34e9-42c7-9445-d2806d156403/fac575ac-7a41-484f-b7ac-875042de11f8?org_if_sml=1&force_format=original',
  page3: undefined,
  page3ImageSrc:
    'https://images.unsplash.com/photo-1627371939259-a5caafe8a67e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NXw&ixlib=rb-4.1.0&q=80&w=1080',
  page2: undefined,
  linkUrlPage1: 'https://www.teleporthq.io',
  action1: undefined,
  link1Url: 'https://www.teleporthq.io',
  action2: undefined,
  page1Description: undefined,
  page1ImageAlt: 'Image for Home',
  page2ImageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
  link1: undefined,
  logoAlt: 'Company Logo',
  link2Url: 'https://www.teleporthq.io',
  page1ImageSrc:
    'https://images.unsplash.com/photo-1617854616735-d4a41198e6c1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NHw&ixlib=rb-4.1.0&q=80&w=1080',
  link4: undefined,
  link3Url: 'https://www.teleporthq.io',
  link3: undefined,
  page4: undefined,
  page2ImageAlt: 'Image for About',
  page4Description: undefined,
  link2: undefined,
  page3ImageAlt: 'Image for Services',
  linkUrlPage2: 'https://www.teleporthq.io',
  linkUrlPage4: 'https://www.teleporthq.io',
  rootClassName: '',
}

Navbar8.propTypes = {
  page1: PropTypes.element,
  linkUrlPage3: PropTypes.string,
  page4ImageSrc: PropTypes.string,
  page4ImageAlt: PropTypes.string,
  page2Description: PropTypes.element,
  page3Description: PropTypes.element,
  logoSrc: PropTypes.string,
  page3: PropTypes.element,
  page3ImageSrc: PropTypes.string,
  page2: PropTypes.element,
  linkUrlPage1: PropTypes.string,
  action1: PropTypes.element,
  link1Url: PropTypes.string,
  action2: PropTypes.element,
  page1Description: PropTypes.element,
  page1ImageAlt: PropTypes.string,
  page2ImageSrc: PropTypes.string,
  link1: PropTypes.element,
  logoAlt: PropTypes.string,
  link2Url: PropTypes.string,
  page1ImageSrc: PropTypes.string,
  link4: PropTypes.element,
  link3Url: PropTypes.string,
  link3: PropTypes.element,
  page4: PropTypes.element,
  page2ImageAlt: PropTypes.string,
  page4Description: PropTypes.element,
  link2: PropTypes.element,
  page3ImageAlt: PropTypes.string,
  linkUrlPage2: PropTypes.string,
  linkUrlPage4: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Navbar8
